"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("@/Jetstream/Button"));
var inertia_react_1 = require("@inertiajs/inertia-react");
var react_i18next_1 = require("react-i18next");
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var UserSettingsForm_module_css_1 = __importDefault(require("./UserSettingsForm.module.css"));
var UserSettingsFormItem_1 = __importDefault(require("../UserSettings/UserSettingsFormItem"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var i18n_1 = __importDefault(require("../i18n"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var ChangePasswordForm_1 = __importDefault(require("./ChangePasswordForm"));
var material_1 = require("@mui/material");
var Input_1 = __importDefault(require("@/Jetstream/Input"));
var q_play_components_2 = require("@nordicscreen/q-play-components");
var react_bootstrap_1 = require("react-bootstrap");
var inertia_1 = require("@inertiajs/inertia");
var ChangeEmailAddressForm_1 = __importDefault(require("./ChangeEmailAddressForm"));
var defaultErrors = { fullName: "", phoneNumber: "", };
var defaultProps = { saving: false, saved: false, text: "" };
var defaultUserAvatar = "/images/default-user.png";
var partnerSuffix = " (partner)";
var nordicScreenSuffix = " (NordicScreen)";
var apiSuffix = " (api)";
var validation = function (error) {
    var checkValidation = 0;
    Object.values(error).forEach(function (val) {
        if (val.length > 0) {
            checkValidation += 1;
        }
    });
    return checkValidation;
};
var UserSettingsForm = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var photoRef = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(null), photoPreview = _a[0], setPhotoPreview = _a[1];
    var page = (0, useTypedPage_1.default)();
    var _b = (0, react_1.useState)(defaultProps), props = _b[0], setProps = _b[1];
    var _c = (0, react_1.useState)(defaultErrors), error = _c[0], setError = _c[1];
    var _d = (0, react_1.useState)(false), isChangeEmailAddressModalShown = _d[0], setChangeEmailAddressModalShown = _d[1];
    var _e = (0, react_1.useState)(false), isChangePasswordModalShown = _e[0], setChangePasswordModalShown = _e[1];
    var form = (0, inertia_react_1.useForm)({
        profilePhotoPath: "",
        fullName: "",
        phoneNumber: "",
        emailAddress: "",
        languageFormat: "",
        acceptsNotifications: false,
        acceptsProductUpdates: false,
    });
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var profile, redactedName;
            return __generator(this, function (_a) {
                profile = page.props.user;
                redactedName = "";
                if (profile.name.endsWith(partnerSuffix))
                    redactedName = profile.name.substring(0, profile.name.length - partnerSuffix.length);
                else if (profile.name.endsWith(nordicScreenSuffix))
                    redactedName = profile.name.substring(0, profile.name.length - nordicScreenSuffix.length);
                else if (profile.name.endsWith(apiSuffix))
                    redactedName = profile.name.substring(0, profile.name.length - apiSuffix.length);
                photoPreview || profile.profile_photo_path ? "" : deletePhoto();
                form.setData({
                    profilePhotoPath: profile.profile_photo_path,
                    fullName: redactedName ? redactedName : profile.name ? profile.name : "",
                    phoneNumber: profile.phone_number ? profile.phone_number : "",
                    emailAddress: profile.email ? profile.email : "",
                    languageFormat: profile.language_format ? profile.language_format : i18n_1.default.language,
                    acceptsNotifications: profile.accepts_notifications ? profile.accepts_notifications : false,
                    acceptsProductUpdates: profile.accepts_product_updates ? profile.accepts_product_updates : false,
                });
                return [2 /*return*/];
            });
        }); };
        fetchData();
    }, []);
    var onSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var profile, response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    profile = {
                        id: page.props.user.id,
                        profilePhotoPath: photoPreview || form.data.profilePhotoPath,
                        name: form.data.fullName,
                        phoneNumber: form.data.phoneNumber,
                        languageFormat: form.data.languageFormat,
                        acceptsNotifications: form.data.acceptsNotifications,
                        acceptsProductUpdates: form.data.acceptsProductUpdates,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    if (!!validation(error)) return [3 /*break*/, 3];
                    setProps({ saving: true });
                    return [4 /*yield*/, ApiManager_1.default.updateProfileInDatabase(profile.id, profile)];
                case 2:
                    response = _a.sent();
                    if (response.message) {
                        setProps({ saved: true, saving: false, text: response.message });
                        setTimeout(function () {
                            setProps({ saved: false });
                        }, 5000);
                    }
                    else {
                        setProps({ saved: true, saving: false, text: response });
                        setTimeout(function () {
                            setProps({ saved: false });
                        }, 3000);
                        inertia_1.Inertia.reload();
                    }
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    console.error("Saving changes to an account failed. Exception: ", e_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var inputValidation = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, id, value, errMsg;
        return __generator(this, function (_b) {
            event.preventDefault();
            _a = event.target, id = _a.id, value = _a.value;
            switch (id) {
                case "fullName":
                    setError({
                        fullName: value.length > 100 ? t("Name cannot be longer than 100 characters") : "",
                        phoneNumber: error.phoneNumber
                    });
                    break;
                case "phoneNumber":
                    {
                        errMsg = value.length > 19 ? t("Phone number cannot be longer than 19 characters") : "";
                        errMsg = !(/^(?:\+?\d+)$/.test(value)) ? t("Phone number can only contain the following characters: +, 0-9") : errMsg;
                        setError({
                            phoneNumber: errMsg,
                            fullName: error.fullName
                        });
                        break;
                    }
                default:
                    break;
            }
            return [2 /*return*/];
        });
    }); };
    var selectNewPhoto = function () {
        photoRef.current.click();
    };
    function updatePhotoPreview() {
        var _a, _b;
        var photo = (_b = (_a = photoRef.current) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0];
        if (!photo) {
            return;
        }
        var reader = new FileReader();
        reader.onload = function (e) {
            var _a;
            setPhotoPreview((_a = e.target) === null || _a === void 0 ? void 0 : _a.result);
        };
        reader.readAsDataURL(photo);
    }
    function deletePhoto() {
        var reader = new FileReader();
        reader.onload = function (e) {
            var res = e.target.result;
            setPhotoPreview(res);
        };
        var xhr = new XMLHttpRequest();
        xhr.open("GET", defaultUserAvatar, true);
        xhr.responseType = "blob";
        xhr.onload = function () {
            var photo = this.response;
            reader.readAsDataURL(photo);
        };
        xhr.send();
        clearPhotoFileInput();
    }
    function clearPhotoFileInput() {
        var _a;
        if ((_a = photoRef.current) === null || _a === void 0 ? void 0 : _a.value) {
            photoRef.current.value = "";
        }
    }
    return (react_1.default.createElement("form", { onSubmit: onSubmit, encType: "multipart/form-data" },
        react_1.default.createElement("div", { id: UserSettingsForm_module_css_1.default.formContainer },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-sm-4" },
                    react_1.default.createElement("div", { className: UserSettingsForm_module_css_1.default.title },
                        react_1.default.createElement("span", null, t("Profile"))),
                    react_1.default.createElement("div", { className: "d-flex align-items-center mb-4" },
                        react_1.default.createElement("img", { className: "rounded-circle object-cover", style: { width: "50px", height: "50px" }, src: photoPreview || page.props.user.profile_photo_path || defaultUserAvatar, onError: function (_a) {
                                var currentTarget = _a.currentTarget;
                                currentTarget.src = defaultUserAvatar;
                            }, "data-cy": "profilePictureImg" }),
                        page.props.user.sso_provider ?
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(material_1.Tooltip, { title: t("Your profile picture is managed by your organization"), placement: "bottom" },
                                    react_1.default.createElement("button", { type: "button", className: UserSettingsForm_module_css_1.default.changeProfilePhotoContainer + " " + UserSettingsForm_module_css_1.default.changeProfilePhotoDisabled, style: { backgroundColor: "var(--secondary-color)" }, "data-cy": "profilePictureChangeButton" }, t("Change"))),
                                react_1.default.createElement(material_1.Tooltip, { title: t("Your profile picture is managed by your organization"), placement: "bottom" },
                                    react_1.default.createElement("button", { type: "button", className: UserSettingsForm_module_css_1.default.trashcanButtonDisabled, "data-cy": "profilePictureRemoveButton" },
                                        react_1.default.createElement("img", { src: "/images/trashcan-icon.svg" }))))
                            :
                                react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(Button_1.default, { style: { backgroundColor: "var(--secondary-color)" }, className: UserSettingsForm_module_css_1.default.changeProfilePhotoContainer, borderRadius: "4px", type: "button", onClick: selectNewPhoto, "data-cy": "profilePictureChangeButton" }, t("Change")),
                                    react_1.default.createElement(Button_1.default, { className: UserSettingsForm_module_css_1.default.trashcanButtonContainer, borderRadius: "4px", type: "button", onClick: deletePhoto, "data-cy": "profilePictureRemoveButton" },
                                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTrashCan })),
                                    react_1.default.createElement(Input_1.default, { type: "file", ref: photoRef, className: "d-none", onChange: updatePhotoPreview, "data-cy": "profilePictureFileInput" }))),
                    react_1.default.createElement(UserSettingsFormItem_1.default, { text: t("Your name"), id: "fullName", type: "text", value: form.data.fullName, className: form.data.fullName.length > 0 ? "is-invalid ".concat(UserSettingsForm_module_css_1.default.inputField) : UserSettingsForm_module_css_1.default.inputField, required: true, onChange: function (e) { inputValidation(e); form.setData("fullName", e.currentTarget.value); }, error: error.fullName, labelText: t("(Required)"), dataCy: "fullNameInput" }),
                    react_1.default.createElement(UserSettingsFormItem_1.default, { text: t("Phone"), id: "phoneNumber", type: "text", value: form.data.phoneNumber, className: form.data.phoneNumber.length > 0 ? "is-invalid ".concat(UserSettingsForm_module_css_1.default.inputField) : UserSettingsForm_module_css_1.default.inputField, required: false, onChange: function (e) { inputValidation(e); form.setData("phoneNumber", e.currentTarget.value); }, error: error.phoneNumber, dataCy: "phoneNumberInput" }),
                    react_1.default.createElement(UserSettingsFormItem_1.default, { text: t("Email"), id: "emailAddress", type: "email", value: form.data.emailAddress, className: form.data.emailAddress.length > 0 ? "is-invalid ".concat(UserSettingsForm_module_css_1.default.inputFieldDisabled) : UserSettingsForm_module_css_1.default.inputFieldDisabled, required: true, onChange: function (e) { inputValidation(e); form.setData("emailAddress", e.currentTarget.value); }, labelText: t("(Required)"), disabled: true, dataCy: "emailAddressInput" },
                        react_1.default.createElement(material_1.Tooltip, { title: t("Your email address is verified"), placement: "bottom" },
                            react_1.default.createElement("img", { src: "/images/checkmark-icon.svg", style: { width: "15px", marginLeft: "0.5rem" } })),
                        page.props.user.sso_provider ?
                            react_1.default.createElement(material_1.Tooltip, { title: t("Your email address is managed by your organization"), placement: "bottom" },
                                react_1.default.createElement("button", { type: "button", className: UserSettingsForm_module_css_1.default.penIcon + " " + UserSettingsForm_module_css_1.default.penIconDisabled, "data-cy": "changeEmailAddressModalButton" },
                                    react_1.default.createElement("img", { src: "/images/pen-edit-icon.svg" })))
                            :
                                react_1.default.createElement(material_1.Tooltip, { title: t("Change your email address"), placement: "bottom" },
                                    react_1.default.createElement("button", { type: "button", className: UserSettingsForm_module_css_1.default.penIcon, onClick: function () { return setChangeEmailAddressModalShown(function (state) { return !state; }); }, "data-cy": "changeEmailAddressModalButton" },
                                        react_1.default.createElement("img", { src: "/images/pen-edit-icon.svg" }))),
                        react_1.default.createElement(q_play_components_1.Modal, { dataCy: "changeEmailAddressModal", headerText: t("Change Email Address"), isShown: isChangeEmailAddressModalShown, onClose: function () { return setChangeEmailAddressModalShown(function (state) { return !state; }); }, body: react_1.default.createElement(ChangeEmailAddressForm_1.default, null), centered: true })),
                    page.props.user.sso_provider ?
                        react_1.default.createElement(material_1.Tooltip, { title: t("Your password is managed by your organization"), placement: "bottom" },
                            react_1.default.createElement("button", { type: "button", className: UserSettingsForm_module_css_1.default.resetPasswordButtonDisabled, style: { backgroundColor: "var(--secondary-color)" }, "data-cy": "resetPasswordModalButton" }, t("Reset Password")))
                        :
                            react_1.default.createElement(Button_1.default, { style: { backgroundColor: "var(--secondary-color)" }, className: UserSettingsForm_module_css_1.default.resetPasswordButtonContainer, borderRadius: "4px", type: "button", onClick: function () { return setChangePasswordModalShown(function (state) { return !state; }); }, "data-cy": "resetPasswordModalButton" }, t("Reset Password")),
                    react_1.default.createElement(q_play_components_1.Modal, { dataCy: "changePasswordModal", headerText: t("Change Password"), isShown: isChangePasswordModalShown, onClose: function () { return setChangePasswordModalShown(function (state) { return !state; }); }, body: react_1.default.createElement(ChangePasswordForm_1.default, null), centered: true })),
                react_1.default.createElement("div", { className: "col-sm-4" },
                    react_1.default.createElement("div", { className: UserSettingsForm_module_css_1.default.title },
                        react_1.default.createElement("span", null, t("Language and formats"))),
                    react_1.default.createElement("div", { className: UserSettingsForm_module_css_1.default.inputContainer },
                        react_1.default.createElement(Label_1.default, { htmlFor: "languageFormat", className: UserSettingsForm_module_css_1.default.label }, t("Language")),
                        react_1.default.createElement("div", { className: UserSettingsForm_module_css_1.default.inputFieldContainer },
                            react_1.default.createElement("select", { value: form.data.languageFormat, onChange: function (e) { return form.setData("languageFormat", e.currentTarget.value); }, "data-cy": "languageSelect" },
                                react_1.default.createElement("option", { value: "en" }, "English"),
                                react_1.default.createElement("option", { value: "da" }, "Danish"))))),
                react_1.default.createElement("div", { className: "col-sm-4" },
                    react_1.default.createElement("div", { className: UserSettingsForm_module_css_1.default.title },
                        react_1.default.createElement("span", null, t("Notifications"))),
                    react_1.default.createElement("div", { className: "d-flex align-items-center" },
                        react_1.default.createElement(react_bootstrap_1.Form.Check, { id: "acceptsNotifications", className: UserSettingsForm_module_css_1.default.checkboxContainer },
                            react_1.default.createElement(react_bootstrap_1.Form.Check.Input, { type: "checkbox", name: "acceptsNotifications", checked: form.data.acceptsNotifications, onChange: function (e) { return form.setData("acceptsNotifications", e.currentTarget.checked ? true : false); }, "data-cy": "acceptsNotificationsInput" }),
                            react_1.default.createElement(react_bootstrap_1.Form.Check.Label, { className: UserSettingsForm_module_css_1.default.checkboxLabel }, t("I want to receive short news once a month")))),
                    react_1.default.createElement("div", { className: "d-flex align-items-center mt-3" },
                        react_1.default.createElement(react_bootstrap_1.Form.Check, { id: "acceptsProductUpdates", className: UserSettingsForm_module_css_1.default.checkboxContainer },
                            react_1.default.createElement(react_bootstrap_1.Form.Check.Input, { type: "checkbox", name: "acceptsProductUpdates", checked: form.data.acceptsProductUpdates, onChange: function (e) { return form.setData("acceptsProductUpdates", e.currentTarget.checked ? true : false); }, "data-cy": "acceptsProductUpdatesInput" }),
                            react_1.default.createElement(react_bootstrap_1.Form.Check.Label, { className: UserSettingsForm_module_css_1.default.checkboxLabel }, t("I want to be notified when there's important information, about the product(s) I use"))))))),
        react_1.default.createElement("div", { id: UserSettingsForm_module_css_1.default.buttonContainer },
            props.saved ? react_1.default.createElement("span", { style: { fontFamily: "Geomanist", margin: "auto 1rem" } }, t(props.text)) : null,
            react_1.default.createElement(q_play_components_2.Button, { className: props.saving ? "opacity-50" : "opacity-100", style: { backgroundColor: "#A1C038", width: "136px", color: "var(--info-color)" }, size: "normal", isDisabled: props.saving, text: t("Save"), dataCy: "saveButton" }))));
};
exports.default = UserSettingsForm;
